import type { MouseEvent } from 'react';

import { ButtonClose } from '@adflow/frontend/ui-buttons';

export interface ToastCloseButtonProps {
	closeToast: (e: MouseEvent<HTMLElement>) => void;
}

export function ToastCloseButton({ closeToast }: ToastCloseButtonProps) {
	return (
		<ButtonClose
			onClick={closeToast}
			css={{ color: 'inherit' }}
			data-testid="close-toast"
		/>
	);
}
